import React, {useEffect, useState} from 'react';

import {
    Box,
    DialogContentText,
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Tab,
    Tabs,
    Theme,
    Typography
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {Block, Close, LocalAtm, MoreVert, CurrencyExchange} from '@mui/icons-material';
import {eliminarCaja, inactivarCaja, mostrarCajaById} from '../../redux/reducers/cajasReducers';
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {formatPeso, hasPermissionTo, PERSMISOS} from "../../helpers";
import ConfirmDialog from "../../components/ConfirmDialog";
import Crear, {ACTIONS} from "./crear";
import {AppBar, ButtonResponsive, LoadingProgress, MostrarError} from "../../components";
import Strings from "../../assets/strings";

import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import CajaCierres from "./CajaCierres";
import CajaMovimientos from "./CajaMovimientos";

const useStyles = makeStyles((theme:Theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: 224,
    },
    tabs: {
        marginBottom: theme.spacing(1),
    },
    title: {
        flexGrow: 1,
        fontWeight: "normal",
    },
    tapTop:{
        [theme.breakpoints.up('md')]: {
            display: "flex",
            justifyContent: "space-between",
            "&>div:last-child":{
                width: 200,
            }
        }
    },
    top:{
        marginBottom: theme.spacing(1),
        padding: theme.spacing(1),
        marginRight: theme.spacing(1.2),
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px dashed #a1a1a1",

    },
  }));
export default function CajaDetails() {
    const classes = useStyles();
    let navigate = useNavigate();
    let {state:urlState, pathname} = useLocation();
    let dispatch = useAppDispatch();
    const { byId: caja,error, status} = useAppSelector(state => state.cajas)

    const {cajId} = useParams()
    const [activeTab,setActiveTab] = useState(0);
    const [showMenu, setShowMenu] = useState(null);

    useEffect(() => {
        if(cajId) {
            dispatch(mostrarCajaById(parseInt(cajId)))
        }
    }, [cajId,dispatch]);

    // const addFilter = (obj:any)=>{
    //     return setState(prev=>({...prev,obj}));
    // }


    function TabPanel(props:any) {
        const { children, value, index, ...other } = props;
        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`full-width-tabpanel-${index}`}
                aria-labelledby={`full-width-tab-${index}`}
                {...other}
            >
                {value === index && <Box p={1}>{children}</Box>}
            </Typography>
        );
    }




    return <>
        <AppBar title={caja?.descripcion || "Detalles caja"} />


        <div className="contentInner">
            {status === "loading" && <LoadingProgress vh/>}
            <MostrarError errors={error}/>

            <Box sx={{
                display:"flex",
                justifyContent:"space-between",
                alignItems:"center",
                background: !!caja?.inactivo? "#fccab7" : "#e6e6e6",
                paddingLeft:2,
                paddingRight:1
            }}>
                <Typography sx={{marginRight:"auto", fontWeight:"500"}} className={"text-red"}>
                    {!!caja?.inactivo && "Caja Inactiva"}
                </Typography>
                <ButtonResponsive icon={<MoreVert/>} text={Strings.opciones} onClick={(e:any)=>setShowMenu(e.currentTarget)}/>
                <Menu anchorEl={showMenu} open={Boolean(showMenu)} onClose={()=>setShowMenu(null)}>
                    {hasPermissionTo(PERSMISOS.cajasActualizar) &&
                        <MenuItem onClick={()=> {
                            setShowMenu(null);
                            navigate(pathname,{state:{action:ACTIONS.AJUSTAR,...caja,cajasMovimientos:undefined,cajasCierres:undefined}})}} >
                            <ListItemIcon>
                                <CurrencyExchange fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>{Strings.ajustar}</ListItemText>
                        </MenuItem>
                    }
                    {hasPermissionTo(PERSMISOS.cajasRealizarCierres) &&
                        <MenuItem onClick={()=>{
                            setShowMenu(null);
                            navigate(pathname,{state:{action:ACTIONS.CERRAR,...caja,cajasMovimientos:undefined,cajasCierres:undefined}})}} >
                            <ListItemIcon>
                                <LocalAtm fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>{Strings.cerrar} {Strings.caja}</ListItemText>
                        </MenuItem>
                    }
                    {hasPermissionTo(PERSMISOS.cajasEliminar) &&
                        <MenuItem onClick={() => {
                            setShowMenu(null);
                            navigate(pathname, {state:{confirmDialog: {inactivarCaja: caja?.id}}})
                        }}>
                            <ListItemIcon>
                                <Block fontSize="small" sx={{color: "warning.main"}}/>
                            </ListItemIcon>
                            <ListItemText sx={{color: "warning.main"}}> {!!caja?.inactivo ? "Activar":"Inactivar"} </ListItemText>

                        </MenuItem>
                    }
                    {hasPermissionTo(PERSMISOS.cajasEliminar) &&
                        <MenuItem onClick={() => {
                            setShowMenu(null);
                            navigate(pathname, {state:{confirmDialog: {delCaja: caja?.id}}})
                        }} sx={{color:"error.main"}}>
                            <ListItemIcon>
                                <Close sx={{color: "error.main"}} fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>Eliminar</ListItemText>
                        </MenuItem>
                    }
                </Menu>
            </Box>


            <div className={classes.tapTop}>
                {caja?.cajasCierres?.items && caja?.cajasCierres?.items.length > 0 ?(
                    <Tabs
                        value={activeTab}
                        onChange={(e,v)=>setActiveTab(v)}
                        className={classes.tabs}
                        //  variant="fullWidth"
                    >
                        <Tab  value={0} label={Strings.movimientos} />
                        <Tab  value={1} label={Strings.cierres}  />
                    </Tabs>
                ):(<div/>)

                }
                <div className={classes.top}>
                    <span>{Strings.balance}: </span>
                    <span>{formatPeso(caja?.balance)}</span>
                </div>
            </div>
            {caja?.id && activeTab === 0 &&
                <CajaMovimientos defaultMovimientos={caja.cajasMovimientos} cajId={caja?.id}/>
            }

            {caja?.id && activeTab === 1 &&
                <CajaCierres defaultCierres={caja?.cajasCierres} cajId={caja?.id}/>
            }
        </div>
        <Crear/>
        {urlState?.confirmDialog?.delCaja &&
            <ConfirmDialog onConfirm={()=>dispatch(eliminarCaja(urlState.confirmDialog.delCaja))} />
        }
        {urlState?.confirmDialog?.inactivarCaja &&
            <ConfirmDialog onConfirm={()=>dispatch(inactivarCaja(urlState.confirmDialog.inactivarCaja))} mode={"warning"} >
                <DialogContentText>
                    ¿Seguro que deseas {caja?.inactivo?" Activar ":" inactivar "} esta caja?
                </DialogContentText>
            </ConfirmDialog>
        }

    </>;
}

